import React from "react";

/* Zelfherstel bij wit scherm: verwijder service workers + caches en herlaad.
   Oorzaak witte schermen: verouderde PWA-cache met oude JS-chunks na een deploy. */
export async function herstelApp() {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((k) => window.caches.delete(k)));
    }
  } catch { /* doorgaan met reload */ }
  window.location.reload();
}

const isChunkFout = (msg) =>
  /ChunkLoadError|Loading chunk|Loading CSS chunk|Unexpected token '<'|importing a module script failed|Failed to fetch dynamically imported/i.test(msg);

export class RecoveryBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const msg = String(error?.message || error || "");
    // Chunk-/cachefouten: éénmalig automatisch herstellen zonder tussenscherm
    if (isChunkFout(msg) && !sessionStorage.getItem("bpt_auto_herstel")) {
      sessionStorage.setItem("bpt_auto_herstel", "1");
      herstelApp();
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || "Onbekende fout");
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        background: "#0f172a", fontFamily: "system-ui, sans-serif", padding: 24,
      }} data-testid="recovery-screen">
        <div style={{
          background: "#fff", borderRadius: 12, padding: "32px 36px", maxWidth: 460,
          boxShadow: "0 20px 60px rgba(0,0,0,.4)", textAlign: "center",
        }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>&#9888;&#65039;</div>
          <h1 style={{ fontSize: 20, margin: "0 0 8px", color: "#0f172a" }}>
            Er ging iets mis bij het laden
          </h1>
          <p style={{ fontSize: 14, color: "#475569", margin: "0 0 20px" }}>
            Dit komt meestal door een verouderde app-versie in de browser-cache.
            Klik hieronder om de app te herstellen — je gegevens blijven bewaard.
          </p>
          <button
            onClick={() => { sessionStorage.removeItem("bpt_auto_herstel"); herstelApp(); }}
            data-testid="recovery-herstel-btn"
            style={{
              background: "#0D3B66", color: "#fff", border: 0, borderRadius: 8,
              padding: "12px 28px", fontSize: 15, fontWeight: 600, cursor: "pointer",
            }}>
            App herstellen &amp; opnieuw laden
          </button>
          <div style={{ marginTop: 16, fontSize: 11, color: "#94a3b8", wordBreak: "break-word" }}>
            {msg.slice(0, 160)}
          </div>
        </div>
      </div>
    );
  }
}
